
define('ldsh!modules/editor/templates/elements/social', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="ed-social-block ed-facebook js-facebook"></div>\n<div class="ed-social-block ed-twitter js-twitter"></div>\n<div class="ed-social-block ed-google js-google"></div>\n';

}
return __p
};});

